import { Button } from 'cpool-components/input/Button';
import { ButtonVariant } from 'cpool-components/input/Button/types';
import { useTranslation } from 'react-i18next';
import { LuFileSearch } from 'react-icons/lu';

import { LEAD_DETAILS_OVERLAYS } from '~/features/leadDetails/constants/overlays';
import { useLeadDetailsModalNavigation } from '~/features/leadDetails/hooks/useLeadDetailsModalNavigation';

const LookupSchufaButton: React.FC = () => {
    const { t } = useTranslation();
    const { openModal } = useLeadDetailsModalNavigation();

    return (
        <Button
            variant={ButtonVariant.SECONDARY}
            iconLeft={<LuFileSearch />}
            onClick={() => openModal(LEAD_DETAILS_OVERLAYS.SCHUFA)}
        >
            {t('BANK_CREDIT_REQUEST.REFINANCE_PLANNER.VIEW_SCHUFA')}
        </Button>
    );
};

export default LookupSchufaButton;
